import React from 'react';
import StatusDot from './StatusDot';

const AppCard = ({ app, status = 'unknown' }) => {
  const clickable = Boolean(app.url);
  const onClick = () => {
    if (!clickable) return;
    window.open(app.url, '_blank', 'noopener,noreferrer');
  };
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!clickable}
      className="relative flex flex-col items-center justify-center gap-2 rounded-2xl border border-cyan-400/15 bg-[#12161f] p-5 text-center shadow-lg transition hover:-translate-y-0.5 hover:border-cyan-400/40 disabled:opacity-50"
    >
      <span className="absolute top-3 right-3">
        <StatusDot status={status} />
      </span>
      <span className="text-3xl" aria-hidden>{app.icon}</span>
      <span className="font-semibold text-zinc-100">{app.name}</span>
      <span className="text-[10px] uppercase tracking-wide text-zinc-500">{app.location}</span>
    </button>
  );
};

export default AppCard;
